/**
 * Upkeep Budget Monitoring API Configuration
 * 
 * Centralized endpoint constants for Upkeep Budget Monitoring API
 */

export const UPKEEP_MONITORING_API_CONFIG = {
  BASE_PATH: '/odoo/budget-monitoring',
  
  endpoints: {
    UPKEEP_BUDGET_REPORT: '/odoo/budget-monitoring/upkeep-budget-report',
  },
} as const;

/**
 * Default filter settings
 */
export const UPKEEP_MONITORING_DEFAULTS = {
  REVISION: 0,
  COMPANY_ID: 1,
} as const;

/**
 * Date format constants
 */
export const DATE_FORMATS = {
  API_YEAR: 'YYYY',
  API_MONTH: 'MM',
  DISPLAY: 'MMMM YYYY',
} as const;
